import React from "react";
import { Box, Button, Grid, LinearProgress } from "@material-ui/core";
import TextFieldHelper from "../../UI/FormHelper/TextFieldHelper";
import UserAutoComplete from "../../Form/UserAutoComplete";
import Wrapper from "../../../hoc/Wrapper/Wrapper";

const BankAccountAddFormFields = (props) => {
  const {
    values,
    // touched,
    // handleChange,
    // isValid,
    // setFieldTouched,
    setFieldValue,
    // handleClose,
    handleSubmit,
    // errors,
  } = props;

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper title={"بانک"} fieldName={"bank"} {...props} />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                title={"کاربر"}
                fieldName={"user_id"}
                setFieldValue={setFieldValue}
                fieldNameShow={"user_fullname"}
                value={values.user_fullname}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper title={"شعبه"} fieldName={"branch"} {...props} />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"کد شعبه"}
                fieldName={"branch_code"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره حساب"}
                fieldName={"account"}
                {...props}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره کارت"}
                fieldName={"card"}
                {...props}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box p={1}>
              <TextFieldHelper title={"شبا"} fieldName={"ibn"} {...props} />
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box p={1}>
              <TextFieldHelper
                title={"توضیحات"}
                fieldName={"description"}
                {...props}
              />
            </Box>
          </Grid>

          {props.isEdit ? (
            <Wrapper>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"تاریخ ویرایش"}
                    fieldName={"updated_at"}
                    {...props}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"تاریخ ثبت"}
                    fieldName={"created_at"}
                    disabled={true}
                    {...props}
                  />
                </Box>
              </Grid>
            </Wrapper>
          ) : null}
        </Grid>

        <Box mt={2}>
          {props.loading ? (
            <Wrapper>
              <Button
                fullwidth={true}
                size={"large"}
                disabled={true}
                color={"default"}
              >
                در حال ارسال
              </Button>
              <LinearProgress />
            </Wrapper>
          ) : (
            <Button
              variant={"contained"}
              type="submit"
              size={"large"}
              fullWidth={true}
              color={"primary"}
            >
              {props.isEdit ? "ثبت ویرایش" : "افزودن حساب بانکی"}
            </Button>
          )}
        </Box>
      </form>
    </div>
  );
};

export default BankAccountAddFormFields;
